import {
  POPULATE_REGISTER_API_RESPONSE,
  POPULATE_MANIFEST_RESPONSE,
  POPULATE_SHIPPING_RESPONSE,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_REGISTER_API_RESPONSE:
      return {
        ...state,
        registerApiResponse: action.payload,
      };
    case POPULATE_SHIPPING_RESPONSE:
      return {
        ...state,
        shippingResponse: action.payload,
      };
    case POPULATE_MANIFEST_RESPONSE:
      return {
        ...state,
        manifestResponse: action.payload,
      };
    default:
    return state;
  }
};
